import React, { useEffect, useState } from "react";
import axios from "axios";

export default function OnboardingForm() {
    const [date, setDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [merchants, setMerchants] = useState([]);

    const [selectedMerchantId, setSelectedMerchantId] = useState("");
    const [formData, setFormData] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");



    const formatDate = (value) => {
        if (!value) return "";
        const [yyyy, mm, dd] = value.split("-");
        return `${Number(dd)}.${Number(mm)}.${yyyy}`;
    };


    useEffect(() => {
        if (selectedMerchantId) {
            const merchant = merchants.find(m => m.merchantLoginId === selectedMerchantId);
            if (merchant) {

                setFormData({ ...merchant });
            }
        } else {
            setFormData(null);
        }
    }, [selectedMerchantId, merchants]);




    const handleSearch = async () => {
        if (!date) {
            setError("Please select date");
            return;
        }

        setLoading(true);
        setError("");
        setMerchants([]);
        setSelectedMerchantId("");

        try {
            const formattedDate = formatDate(date);
            const res = await axios.post(
                "https://bumppy.com/apibumppypay/v1/web/fingpay/onboardingRequests.php",
                { date: formattedDate },
                {
                    headers: { "Content-Type": "application/json" },
                    transformResponse: [(data) => data]
                }
            );

            const rawData = res.data;

            if (!rawData || rawData.trim().length < 10) {
                setError(`No data available for ${formattedDate}`);
                setLoading(false);
                return;
            }


            const merchantMap = new Map();
            const regex = /\{[\s\S]*?\}(?=\s*\{|$)/g;
            const matches = rawData.match(regex);

            if (!matches) {
                setError("No valid data format found");
                setLoading(false);
                return;
            }

            matches.forEach((jsonStr) => {
                try {
                    const parsed = JSON.parse(jsonStr);
                    if (parsed && parsed.merchant && parsed.merchant.merchantLoginId) {
                        const m = parsed.merchant;
                        merchantMap.set(m.merchantLoginId, m);
                    }
                } catch (e) {
                   
                }
            });

            const finalMerchants = Array.from(merchantMap.values());

            if (finalMerchants.length > 0) {
                setMerchants(finalMerchants);
            } else {
                setError(`No merchant records found for ${formattedDate}`);
            }

        } catch (err) {
            console.error("API Error:", err);
            setError("Server error or network issue");
        } finally {
            setLoading(false);
        }
    };




    const handleChange = (path, value) => {
        setFormData(prev => {
            const keys = path.split('.');
            const newData = { ...prev };
            let current = newData;

            for (let i = 0; i < keys.length - 1; i++) {
                current[keys[i]] = { ...current[keys[i]] };
                current = current[keys[i]];
            }

            current[keys[keys.length - 1]] = value;
            return newData;
        });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError("");
        setSuccess("");

        try {

            const finalPayload = {
                username: "bumppyd",
                supermerchantId: 1179,
                password: "145c5e8f71f46fc7d33407c910ed5d1e",
                latitude: formData.merchantKycAddressData?.shopLatitude || "28.9819005",
                longitude: formData.merchantKycAddressData?.shopLongitude || "78.1617305",
                ipAddress: "35.200.161.138",
                merchant: { ...formData }
            };

            console.log("Submitting Final Payload:", finalPayload);

            const response = await axios.post(
                "https://bumppy.com/apibumppypay/v1/web/fingpay/merchantonboardv2.php",
                finalPayload,
                { headers: { "Content-Type": "application/json" } }
            );

            if (response.data.status === true || response.data.statusCode === 10000) {
                setSuccess("Merchant onboarded successfully!");
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                setError(response.data.message || "Onboarding failed. Please check your credentials.");
            }
        } catch (err) {
            console.error("Submit Error:", err);
            setError("Server error while submitting form.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div id="secure-ui" className="container-xl my-5" style={{ fontFamily: 'sans-serif' }}>

            <style>
                {`
                    .rounded-xl { border-radius: 0.75rem !important; }
                    .rounded-2xl { border-radius: 1rem !important; }
                    .bg-gray-50 { background-color: #f9fafb !important; }
                    .text-blue-800 { color: #1e40af !important; }
                    .bg-blue-600 { background-color: #2563eb !important; }
                    .bg-green-600 { background-color: #16a34a !important; }
                    .extra-small-label { font-size: 0.75rem; font-weight: 700; color: #4c5059; text-transform: uppercase; }
                    .form-underlined {
                        border: none;
                        border-bottom: 1px solid #d1d5db;
                        border-radius: 0;
                        background-color: #f9fafb;
                        padding: 0.5rem;
                    }
                    .form-underlined:focus {
                        outline: none;
                        border-bottom-color: #2563eb;
                        box-shadow: none;
                    }
                    .shadow-lg-custom { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); }
                   
                    /* Animation */
                    @keyframes slideInUp {
                        from { transform: translateY(1rem); opacity: 0; }
                        to { transform: translateY(0); opacity: 1; }
                    }
                    .animate-in-custom { animation: slideInUp 0.5s ease-out forwards; }
                    .hide-arrow {
                          background-image: none !important;  
                         
}
                `}
            </style>


            <div className="pb-4 text-center">
                <h1 className="h3 text-uppercase text-blue-800 fw-bold">AEPS Onbording</h1>
            </div>


            <div className="bg-white border rounded-2xl p-4 p-md-4 shadow-sm">
                <div className="row g-3 align-items-end">
                    <div className="col-12 col-md">
                        <label className="form-label small fw-semibold text-dark mb-2">Select Date</label>
                        <input
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            className="form-control py-3 rounded-xl border bg-gray-50 shadow-none"
                        />
                    </div>
                    <div className="col-12 col-md-auto">
                        <button
                            onClick={handleSearch}
                            disabled={loading}
                            className="btn bg-blue-600 text-white px-5 py-3 rounded-xl fw-bold w-100"
                        >
                            {loading ? "Searching..." : "Search Now"}
                        </button>
                    </div>
                </div>
            </div>


            {merchants.length > 0 && (
                <div className="mt-4">
                    <label className="form-label small fw-semibold mb-2">Select Merchant</label>
                    <div className="position-relative">
                        <select
                            value={selectedMerchantId}
                            onChange={(e) => setSelectedMerchantId(e.target.value)}
                            className="form-select py-3 px-4 border rounded-xl hide-arrow bg-white shadow-none appearance-none"
                        >
                            <option value="">-- Choose Merchant --</option>
                            {merchants.map((m) => (
                                <option key={m.merchantLoginId} value={m.merchantLoginId}>
                                    {m.firstName} {m.lastName} ({m.merchantLoginId})
                                </option>
                            ))}
                        </select>
                        {/* <div className="position-absolute top-50 end-0 translate-middle-y pe-3 pointer-events-none text-secondary">
                            <svg className="h-5 w-5" width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                            </svg>
                        </div> */}
                    </div>
                </div>
            )}


            {formData && (
                <form onSubmit={handleSubmit} className="mt-5 bg-white border rounded-2xl p-4 p-md-5 shadow-lg-custom animate-in-custom">


                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 border-bottom pb-3">
                        <h2 className="h4 fw-bold text-blue-800 mb-3 mb-md-0">Merchant Details Form</h2>
                        <button
                            type="submit"
                            disabled={submitting}
                            className="btn bg-green-600 text-white px-4 py-2 rounded-xl fw-bold hover:bg-green-700 disabled-bg-secondary"
                        >
                            {submitting ? "Submitting..." : "Save Your Details"}
                        </button>
                    </div>


                    {error && <div className="alert alert-danger rounded-3">{error}</div>}
                    {success && <div className="alert alert-success rounded-3">{success}</div>}


                    <div className="row g-4">
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">First Name</label>
                            <input
                                style={{ backgroundColor: '#f3f4f6' }}
                                type="text" value={formData.firstName || ""} onChange={(e) => handleChange('firstName', e.target.value)} className="form-control form-underlined w-100 shadow-none bg-gray-200" />
                        </div>
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">Middle Name</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.middleName || ""} onChange={(e) => handleChange('middleName', e.target.value)} className="form-control form-underlined w-100 shadow-none" />
                        </div>
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">Last Name</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.lastName || ""} onChange={(e) => handleChange('lastName', e.target.value)} className="form-control form-underlined w-100 shadow-none" />
                        </div>
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">Email ID</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.emailId || ""} onChange={(e) => handleChange('emailId', e.target.value)} className="form-control form-underlined w-100 shadow-none" />
                        </div>
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">Phone Number</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.merchantPhoneNumber || ""} onChange={(e) => handleChange('merchantPhoneNumber', e.target.value)} className="form-control form-underlined w-100 shadow-none" />
                        </div>
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">Company Legal Name</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.companyLegalName || ""} onChange={(e) => handleChange('companyLegalName', e.target.value)} className="form-control form-underlined w-100 shadow-none" />
                        </div>
                    </div>


                    <h3 className="h6 fw-semibold mt-5 mb-3 text-secondary">Residential Address</h3>
                    <div className="row g-4">
                        <div className="col-12 col-md-6">
                            <label className="extra-small-label d-block mb-1">Address Line 1</label>
                            <textarea rows={3} value={formData.merchantAddress?.merchantAddress1 || ""} onChange={(e) => handleChange('merchantAddress.merchantAddress1', e.target.value)} className="form-control form-underlined w-100 shadow-none" style={{ resize: 'none' }} />
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="extra-small-label d-block mb-1">Address Line 2</label>
                            <textarea rows={3} value={formData.merchantAddress?.merchantAddress2 || ""} onChange={(e) => handleChange('merchantAddress.merchantAddress2', e.target.value)} className="form-control form-underlined w-100 shadow-none" style={{ resize: 'none' }} />
                        </div>
                    </div>

                    <div className="row g-4 mt-2">
                        <div className="col-6 col-md-3">
                            <label className="extra-small-label d-block mb-1">City</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} placeholder="City" value={formData.merchantAddress?.merchantCityName || ""} onChange={(e) => handleChange('merchantAddress.merchantCityName', e.target.value)} className="form-control form-underlined shadow-none" />
                        </div>
                        <div className="col-6 col-md-3">
                            <label className="extra-small-label d-block mb-1">District</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} placeholder="District" value={formData.merchantAddress?.merchantDistrictName || ""} onChange={(e) => handleChange('merchantAddress.merchantDistrictName', e.target.value)} className="form-control form-underlined shadow-none" />
                        </div>
                        <div className="col-6 col-md-3">
                            <label className="extra-small-label d-block mb-1">State</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} placeholder="State" value={formData.merchantAddress?.merchantState || ""} onChange={(e) => handleChange('merchantAddress.merchantState', e.target.value)} className="form-control form-underlined shadow-none" />
                        </div>
                        <div className="col-6 col-md-3">
                            <label className="extra-small-label d-block mb-1">Pincode</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} placeholder="Pincode" value={formData.merchantAddress?.merchantPinCode || ""} onChange={(e) => handleChange('merchantAddress.merchantPincode', e.target.value)} className="form-control form-underlined shadow-none" />
                        </div>
                    </div>


                    <h3 className="h6 fw-semibold mt-5 mb-3 text-secondary">KYC & Banking</h3>
                    <div className="row g-4">
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">GST Number</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.kyc?.gstinNumber || ""} onChange={(e) => handleChange('kyc.gstinNumber', e.target.value)} className="form-control form-underlined shadow-none w-100" />
                        </div>
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">Aadhaar Number</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.kyc?.aadhaarNumber || ""} onChange={(e) => handleChange('kyc.aadhaarNumber', e.target.value)} className="form-control form-underlined shadow-none w-100" />
                        </div>
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">PAN Number</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.kyc?.userPan || ""} onChange={(e) => handleChange('kyc.userPan', e.target.value)} className="form-control form-underlined shadow-none w-100" />
                        </div>
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">Bank Account No.</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.settlementV1?.companyBankAccountNumber || ""} onChange={(e) => handleChange('settlementV1.companyBankAccountNumber', e.target.value)} className="form-control form-underlined shadow-none w-100" />
                        </div>
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">Bank Name</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.settlementV1?.companyBankName || ""} onChange={(e) => handleChange('settlementV1.companyBankName', e.target.value)} className="form-control form-underlined shadow-none w-100" />
                        </div>
                        <div className="col-12 col-md-4">
                            <label className="extra-small-label d-block mb-1">Account Holder Name</label>
                            <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.settlementV1?.bankAccountName || ""} onChange={(e) => handleChange('settlementV1.bankAccountName', e.target.value)} className="form-control form-underlined shadow-none w-100" />
                        </div>
                    </div>


                    <h3 className="h6 fw-semibold mt-5 mb-3 text-secondary">Shop Address</h3>
                    <div className="bg-blue-50 p-4 rounded-xl border border-blue-100">
                        <div className="row g-3">
                            <div className="col-12">
                                <label className="extra-small-label opacity-75 d-block mb-1">Shop Full Address</label>
                                <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.merchantKycAddressData?.shopAddress || ""} onChange={(e) => handleChange('merchantKycAddressData.shopAddress', e.target.value)} className="form-control form-underlined shadow-none w-100" />
                            </div>
                            <div className="col-6 col-md-3">
                                <label className="extra-small-label opacity-75" style={{ fontSize: '10px' }}>CITY</label>
                                <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.merchantKycAddressData?.shopCity} onChange={(e) => handleChange('merchantKycAddressData.shopCity', e.target.value)} className="form-control form-underlined shadow-none" />
                            </div>
                            <div className="col-6 col-md-3">
                                <label className="extra-small-label opacity-75" style={{ fontSize: '10px' }}>DISTRICT</label>
                                <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.merchantKycAddressData?.shopDistrict} onChange={(e) => handleChange('merchantKycAddressData.shopDistrict', e.target.value)} className="form-control form-underlined shadow-none" />
                            </div>
                            <div className="col-6 col-md-3">
                                <label className="extra-small-label opacity-75" style={{ fontSize: '10px' }}>STATE</label>
                                <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.merchantKycAddressData?.shopState} onChange={(e) => handleChange('merchantKycAddressData.shopState', e.target.value)} className="form-control form-underlined shadow-none" />
                            </div>
                            <div className="col-6 col-md-3">
                                <label className="extra-small-label opacity-75" style={{ fontSize: '10px' }}>PIN</label>
                                <input style={{ backgroundColor: '#f3f4f6' }} type="text" value={formData.merchantKycAddressData?.shopPincode} onChange={(e) => handleChange('merchantKycAddressData.shopPincode', e.target.value)} className="form-control form-underlined shadow-none" />
                            </div>
                        </div>
                    </div>
                </form>
            )}
        </div>
    );
}